
import { DocumentItem } from "./DocumentItem";

interface Document {
  id: string;
  file_name: string;
  file_path: string;
  display_title: string;
}

interface DocumentListProps {
  documents: Document[];
  canManageDocuments: boolean;
  onDocumentDeleted: (docId: string) => void;
}

export function DocumentList({ documents, canManageDocuments, onDocumentDeleted }: DocumentListProps) {
  if (!documents || (documents?.length || 0) === 0) {
    return (
      <div className="flex flex-col p-3 bg-muted rounded-lg overflow-hidden">
        <p className="text-sm text-muted-foreground">No documents available</p>
      </div>
    );
  }

  return (
    <div className="space-y-2 w-full overflow-hidden">
      {documents.map((doc) => (
        <DocumentItem
          key={doc.id}
          id={doc.id}
          fileName={doc.file_name}
          filePath={doc.file_path}
          displayTitle={doc.display_title}
          canManageDocuments={canManageDocuments}
          onDelete={onDocumentDeleted}
        />
      ))}
    </div>
  );
}
